import React from "react";
import { cn } from "../../lib/utils";

/**
 * FlippingCard Component
 * A 3D flipping card component that rotates on hover
 * 
 * @param {Object} props
 * @param {string} props.className - Additional CSS classes
 * @param {number} props.height - Card height in pixels (default: 300)
 * @param {number} props.width - Card width in pixels (default: 350)
 * @param {React.ReactNode} props.frontContent - Content to display on the front face
 * @param {React.ReactNode} props.backContent - Content to display on the back face
 */
export function FlippingCard({
  className,
  frontContent,
  backContent,
  height = 300,
  width = 350,
}) {
  return (
    <div
      className="group/flipping-card [perspective:1000px]"
      style={
        {
          "--height": `${height}px`,
          "--width": `${width}px`,
        }
      }
    >
      <div
        className={cn(
          "relative rounded-xl border border-neutral-200 bg-white shadow-lg transition-all duration-700 [transform-style:preserve-3d] group-hover/flipping-card:[transform:rotateY(180deg)] dark:border-neutral-800 dark:bg-neutral-950",
          "h-[var(--height)] w-[var(--width)]",
          className
        )}
      >
        {/* Front Face */}
        <div className="absolute inset-0 h-full w-full rounded-[inherit] bg-white text-neutral-950 [transform-style:preserve-3d] [backface-visibility:hidden] [transform:rotateY(0deg)] dark:bg-zinc-950 dark:text-neutral-50">
          <div className="h-full w-full">
            {frontContent}
          </div>
        </div>
        {/* Back Face */}
        <div className="absolute inset-0 h-full w-full rounded-[inherit] bg-white text-neutral-950 [transform-style:preserve-3d] [backface-visibility:hidden] [transform:rotateY(180deg)] dark:bg-zinc-950 dark:text-neutral-50">
          <div className="h-full w-full">
            {backContent}
          </div>
        </div>
      </div>
    </div>
  );
}

